import React from 'react';
import { AlertTriangle, Shield } from 'lucide-react';
export function AllergenSummaryCard() {
  const confirmedAllergens = ['Soy', 'Tree Nuts'];
  const mayContainAllergens = ['Milk', 'Wheat', 'Fish'];
  return <div className="bg-white rounded-lg border p-6" data-id="element-2">
      <div className="flex items-center space-x-2 mb-4" data-id="element-3">
        <Shield className="w-5 h-5 text-orange-600" data-id="element-4" />
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-5">
          Allergen Summary
        </h2>
      </div>
      <div className="space-y-4" data-id="element-6">
        {/* Confirmed Allergens */}
        <div data-id="element-7">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-8">Contains:</h3>
          <div className="flex flex-wrap gap-2" data-id="element-9">
            {confirmedAllergens.map(allergen => <span key={allergen} className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800 border border-red-200" data-id="element-10">
                <AlertTriangle className="w-3 h-3 mr-1" data-id="element-11" />
                {allergen}
              </span>)}
          </div>
          <p className="text-xs text-gray-500 mt-1" data-id="element-12">
            Auto-generated from ingredient analysis
          </p>
        </div>
        {/* May Contain Allergens */}
        <div data-id="element-13">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-14">
            May Contain (Facility Cross-Contamination):
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-15">
            {mayContainAllergens.map(allergen => <span key={allergen} className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 border border-yellow-200" data-id="element-16">
                {allergen}
              </span>)}
          </div>
          <p className="text-xs text-gray-500 mt-1" data-id="element-17">
            Based on shared manufacturing facility data
          </p>
        </div>
        {/* Allergen-Free Claims */}
        <div className="pt-4 border-t border-gray-200" data-id="element-18">
          <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-19">
            Verified Allergen-Free:
          </h3>
          <div className="flex flex-wrap gap-2" data-id="element-20">
            {['Gluten', 'Eggs', 'Shellfish', 'Peanuts'].map(allergen => <span key={allergen} className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800 border border-green-200" data-id="element-21">
                <Shield className="w-3 h-3 mr-1" data-id="element-22" />
                {allergen}-Free
              </span>)}
          </div>
        </div>
      </div>
    </div>;
}